<template></template>
<script lang="ts" setup>
import { useRouter } from "vue-router";
import { definePage } from "vue-router/auto";
import { useNavigation } from "../composables/useNavigation";

const router = useRouter();
const { getRedirectUrl } = await useNavigation();

const redirectPath = getRedirectUrl();
router.push(redirectPath);

definePage({
	meta: {
		requiresAuth: true,
	},
});
</script>
